import type { IconNode } from '../types';

/**
 * @name eighth-note
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTkgNi01LjItMy45YS41LjUgMCAwIDAtLjguNFYxOCIgLz4KICA8Y2lyY2xlIGN4PSI5IiBjeT0iMTgiIHI9IjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/eighth-note
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const EighthNote: IconNode = [
  ['path', { d: 'm19 6-5.2-3.9a.5.5 0 0 0-.8.4V18' }],
  ['circle', { cx: '9', cy: '18', r: '4' }],
];

export default EighthNote;
